import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { REDUX_LOGGER_IS_ENABLED } from 'config/constants';
import { getAxios, getListAxios } from 'utils/api/axiosClient';
//
import reduxLoggerMiddleware from 'utils/reduxLoggerMiddleware';
import rootReducer from './reducers/root';

export function configureStore(initialState = {}) {
  const middleware = [thunk.withExtraArgument({ getAxios, getListAxios })];

  if (REDUX_LOGGER_IS_ENABLED) {
    middleware.push(reduxLoggerMiddleware);
  }

  let composeEnhancers = compose;
  if (
    process.env.NODE_ENV === 'development' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ // eslint-disable-line
  ) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__; // eslint-disable-line
  }

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  if (import.meta.hot) {
    import.meta.hot.accept('./reducers/root', (mod) => {
      if (mod?.default) {
        store.replaceReducer(mod.default);
      }
    });
  }

  return store;
}
